export default __webpack_public_path__ + "static/media/msTeamsIcon.a1195603.svg";